/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Modality_NoneInputs */

const en_us2_modality_none = /** @type {(inputs: Modality_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing yet`)
};

const pt_br2_modality_none = /** @type {(inputs: Modality_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada ainda`)
};

const es_419_modality_none = /** @type {(inputs: Modality_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada todavía`)
};

const pt_pt2_modality_none = /** @type {(inputs: Modality_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada ainda`)
};

const fr_fr2_modality_none = /** @type {(inputs: Modality_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rien encore`)
};

const de_de2_modality_none = /** @type {(inputs: Modality_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch nichts`)
};

const it_it2_modality_none = /** @type {(inputs: Modality_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora niente`)
};

/**
* | output |
* | --- |
* | "Nothing yet" |
*
* @param {Modality_NoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const modality_none = /** @type {((inputs?: Modality_NoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Modality_NoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_modality_none(inputs)
	if (locale === "es-419") return es_419_modality_none(inputs)
	if (locale === "pt-PT") return pt_pt2_modality_none(inputs)
	if (locale === "fr-FR") return fr_fr2_modality_none(inputs)
	if (locale === "de-DE") return de_de2_modality_none(inputs)
	if (locale === "it-IT") return it_it2_modality_none(inputs)
	return en_us2_modality_none(inputs)
});
export { modality_none as "modality.none" }